const popup = {
  namespaced: true,
  state: {
    param: {},
    dialogTitle: '',
    dialogText: '',
    maxWidth: 300,
    // 팝업 높이. 기본은 내용에 맞춤(undefined)이고 넘겨줄 때만 고정된다.
    // state 에 선언해 두지 않으면 Vue2 가 반응형으로 잡지 못해, 한 번 들어온 값이
    // 세션 내내 모든 팝업에 그대로 남는다.
    height: undefined,
    closable: false,
    callback: undefined,
    customApprove: false,
    approveName: '확인',
  },
  mutations: {
    SET_PARAM(state, value) {
      state.param = value;
    },
    SET_POPUP_TITLE(state, value) {
      state.dialogTitle = value;
    },
    SET_POPUP_TEXT(state, value) {
      state.dialogText = value;
    },
    SET_MAX_WIDTH(state, value) {
      state.maxWidth = value;
    },
    SET_HIGHT(state, value) {
      state.height = value;
    },
    SET_CLOSABLE(state, value) {
      state.closable = value;
    },
    SET_CUSTOM_APPROVE(state, value) {
      state.customApprove = value;
    },
    SET_ALERT_ICON_USED(state, value) {
      state.alertIconUsed = value;
    },
    SET_POPUP(state, value) {
      this.commit('popup/RESET_POPUP');
      state.param = value.param;
      state.dialogTitle = value.title;
      state.dialogText = value.text;
      state.maxWidth = value.width;
      state.height = value.height;
      state.closable = value.closable;
      state.callback = value.callback;
      state.customApprove = value.customApprove;
      state.approveName = value.approveName ? value.approveName : '확인';
    },
    RESET_POPUP(state) {
      state.param = {};
      state.dialogTitle = '';
      state.dialogText = '';
      state.maxWidth = 300;
      state.height = undefined;
      state.closable = false;
      state.callback = undefined;
      state.customApprove = false;
      state.approveName = '확인';
    },
    SET_CALL_BACK(state, value) {
      state.callback = value;
    },
  },
  getters: {},
  actions: {},
};

export default popup;
